<template>
  <div class="reviews">
    <reviews-head :rating="rating" :count="count" :tour-id="getTourId" />
    <reviews-list :reviews="preview.reviews" :item-name="itemName" :expert-data="expertData" />
    <template v-if="hasShowAllButton">
      <div class="reviews__all">
        <yt-button
          color="gray"
          class="reviews__all-button"
          squared
          @click="onShowAll"
        >
          {{ $tc("reviews.all", count) }}
        </yt-button>
      </div>
      <popup v-model="popups.all" :content-overflow="false">
        <transition name="fade" mode="out-in">
          <div v-if="reviews" :key="'popup-reviews'">
            <reviews-head :rating="rating" :count="count" slim />
            <reviews-list :reviews="reviews.reviews" :item-name="itemName" :expert-data="expertData" />
          </div>
          <preloader v-else visible />
        </transition>
      </popup>
    </template>
  </div>
</template>

<script>
import { axiosReviews } from "@/services/scopes/axios-reviews";
import getRating from "@/assets/js/utils/get-rating";
import ReviewsHead from "./reviews-head.vue";
import ReviewsList from "./reviews-list.vue";
import YtButton from "@/components/ui-kit/yt-button/index.vue";
import Popup from "@/components/ui-kit/popup/index.vue";
import Preloader from "@/components/ui-kit/preloader/index.vue";

export default {
  components: {
    ReviewsHead,
    ReviewsList,
    YtButton,
    Popup,
    Preloader,
  },
  props: {
    preview: {
      type: Object,
      required: true,
    },
    tourId: {
      type: [Number, String],
      required: true,
    },
    itemName: {
      type: String,
      default: "",
    },
    expertData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      reviews: null,
      popups: {
        all: false,
      },
    };
  },
  computed: {
    rating() {
      return getRating(this.reviews?.rating || this.preview.rating);
    },
    count() {
      return this.reviews?.count_total || this.preview.count_total;
    },
    hasShowAllButton() {
      return this.count > this.preview.reviews.length;
    },
    getTourId() {
      return this.tourId;
    },
  },
  methods: {
    onShowAll() {
      this.fetchReviews();
      this.popups.all = true;
    },
    async fetchReviews() {
      if (this.reviews) {
        return;
      }

      await axiosReviews
        .getReviews(this.tourId, {
          'sort[date]':'DESC'
        })
        .then(({ data: { data } }) => {
          this.reviews = data;
        })
        .catch(() => {
          this.reviews = this.preview;
        });
    },
    showReviews() {
      if (this.hasShowAllButton) {
        this.onShowAll();
        return;
      }

      this.$scrollTo(this.$el);
    },
  },
};
</script>

<style lang="scss" scoped>
.reviews {
  &__all {
    margin-top: 25px;

    &-button {
      @include mixin.size-sm {
        width: 100%;
      }
    }
  }
}
</style>
